export const BOT_WEB_URL = process.env.VUE_APP_BOT_PROSHIP_WEB || "https://bot.proship.co.th";

// Click handler for the "เชื่อมเพจใหม่" links. Opens the tab synchronously (popup-blocker safe),
// then points it at a one-time bot.proship login link, or the plain site on any failure.
export function openBotLink(event, store) {
  const w = window.open("", "_blank");
  if (!w) return; // blocked: let the anchor's normal href/target behaviour run
  event.preventDefault();
  try { w.opener = null; } catch (e) { /* ignore */ }
  store.dispatch("botPages/getLink").then(url => {
    w.location = url || BOT_WEB_URL;
  }).catch(() => {
    w.location = BOT_WEB_URL;
  });
}

